module.exports = __webpack_public_path__ + "static/recriando-raizes-cb00273ed903801243b547711edfc88a.jpg";